<template>
<div>
  <PAPCreditVsDebitStore ref="papCreditVsDebitStore" />

  <div>
    <h3>PAP Credit vs Debit Report</h3>

    <GenericDatePeriodSelector storeName="papCreditVsDebitStore" />
    <GenericDaysSelector storeName="papCreditVsDebitStore" />
    
    <!-- Toggle switch for showing only totals vs all daily data -->
    <div style="margin: 20px 0; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input 
          type="checkbox" 
          v-model="showOnlyTotal"
          style="margin-right: 10px; transform: scale(1.2);"
        />
        <span style="font-weight: bold;">Show Monthly Total Only (for printing)</span>
      </label>
      <small style="color: #666; margin-left: 30px;">
        Toggle this on to show only monthly totals for quick reports
      </small>
    </div>

    <h3>RCGB</h3>
    <PAPCreditVsDebitSummary location="RCGB" />
    <h3>RMGB</h3>
    <PAPCreditVsDebitSummary location="RMGB" />
    <h3>WGB</h3>
    <PAPCreditVsDebitSummary location="WGB" />
  </div>


</div>
</template>

<script>
import PAPCreditVsDebitStore from './Stores/PAPCreditVsDebitStore.vue'
import PAPCreditVsDebitSummary from './Components/PAPCreditVsDebitSummary.vue'
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'PAPCreditVsDebit',
  mixins : [formatDataMixin],
  components:{PAPCreditVsDebitSummary, PAPCreditVsDebitStore},
  data() {
    return {
      showOnlyTotal: false
    }
  },
  provide() {
    return {
      papCreditVsDebitPage: this,
      page: this,
    }
  },
  computed:{
    timestamps(){ return this.$refs.papCreditVsDebitStore.timestamps},
  },

}
</script>

<style lang="scss" scoped>

</style>
